import { InformationWrapper, Information, Ingredients, IconWrapper, Compliant } from './InformationCollapse.styles'
import Trans from 'next-translate/Trans'
import { Icon } from 'components/Icon'
import React, { useState } from 'react'

type InformationType = {
  label: string
  description: string
}

type InformationCollapseProps = {
  infoList: InformationType[]
}

type RotateMapType = Record<number, boolean>

export const InformationCollapse = ({ infoList }: InformationCollapseProps) => {
  const [rotateMap, setRotateMap] = useState<RotateMapType>(() => 
    Object.fromEntries(infoList.map((_, index) => [index, false]))
  )

  const toggleRotate = (index: number) => {
    setRotateMap(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  return (
    <InformationWrapper>
      {infoList.map((info, index) => (
        <Information.Root key={index}>
          <Information.Trigger onClick={() => toggleRotate(index)}>
            {info.label} 
            <IconWrapper>
              <Icon 
                className={rotateMap[index] ? 'rotate' : ''} 
                size='4' 
                name="arrow-down-line" 
                label="Expand" 
                color="accent-black" 
              />
            </IconWrapper>
          </Information.Trigger>
          <Information.Content>
            <Trans
              i18nKey={info.description}
              components={{ br: <br />, strong: <strong />, Compliant: <Compliant />,Ingredients: <Ingredients /> }}
            />
          </Information.Content>
        </Information.Root>
      ))}
    </InformationWrapper>
  )
}